import { ErrorBoundary } from './components';
import { AppRoutes } from './routes';
import { AppStore } from './store';
import { AppThemeProvider } from './theme';
import { AppSnackBarProvider } from './components/AppSnackBar';
import IdleTimer from './components/IdleTimer';
import WalletContextProvider from './components/Wallet/WalletContextProvider.js';
//import React, { useEffect, useState } from 'react';

/**
 * Root Application Component
 * @component App
 */
const App = () => {
  //this is AI slop that doesnt work 


  // const [wallets, setWallets] = useState([]);

  // useEffect(() => {
  //   // This effect will run whenever the WalletContextProvider re-renders
  //   // It will capture the current wallets state from the context
  //   const contextWallets = WalletContextProvider.useWallets();
  //   setWallets(contextWallets);

  //   // Filter the wallets
  //   const filteredWallets = contextWallets.filter(wallet => 
  //     ['Salmon', 'Backpack'].includes(wallet.adapter.name) &&
  //     wallet.readyState === "Installed"
  //   );

  //   // Update the state with filtered wallets
  //   setWallets(filteredWallets);
  // }, []);
  return (
    <ErrorBoundary name="App">
      <AppStore>
        <WalletContextProvider>
          <IdleTimer />
          <AppThemeProvider>
            <AppSnackBarProvider>
              <AppRoutes />
            </AppSnackBarProvider>
          </AppThemeProvider>
        </WalletContextProvider>
      </AppStore>
    </ErrorBoundary>
  );
};

export default App;
